export const TOKEN_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  RES_ACCESS_TOKEN: 'access_token',
  RES_REFRESH_TOKEN: 'refresh_token',
};
